module.exports = __webpack_public_path__ + "static/media/shopping_tablet.4db880b5.jpg";